import request from '@/utils/request'

// 生产环境api路径

// 获取收录论文数量
export function getCountdata (data) {
  return request({
    url: '/old/countdata',
    method: 'get'
  })
}

// 获取机构信息
export function getOrg (data) {
  return request({
    data: data,
    url: '/old/queryOrganization',
    method: 'post'
  })
}

// 获取top领域信息
export function getRec (data) {
  return request({
    url: '/old/getRecommendedData ',
    method: 'post'
  })
}
// 获取top专家信息
export function getRecExpert (data) {
  return request({
    data: data,
    url: '/old/getRecommendedExpert',
    method: 'post'
  })
}
// 获取top专家信息
export function getDefaultKeywords (data) {
  return request({
    data: data,
    url: '/old/getDefaultKeywords',
    method: 'post'
  })
}


// 开发环境api路径

// // 获取收录论文数量
// export function getCountdata (data) {
//   return request({
//     url: '/test/countdata',
//     method: 'GET'
//   })
// }
// // 获取机构信息
// export function getOrg (data) {
//   return request({
//     data: data,
//     url: '/test/queryOrganization',
//     method: 'post'
//   })
// }

// // 获取top领域信息
// export function getRec (data) {
//   return request({
//     url: '/test/getRecommendedData ',
//     method: 'post'
//   })
// }

// // 获取top专家信息
// export function getRecExpert (data) {
//   return request({
//     data: data,
//     url: '/test/getRecommendedExpert',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/home.js